import { capitalize } from "es-toolkit/string";
import type { RunStatus } from "src/queries/pipelines/pipelineRuns.types";

export const getRunStatusTooltipTitle = (status: RunStatus) =>
  capitalize(status?.replaceAll("_", " "));
